import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import CustomerTickets from '../../modules/customer/pages/CustomerTickets';
import { CustomerAuthProvider, useCustomerAuth } from '../../modules/customer/context/CustomerAuthContext';

const CustomerProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useCustomerAuth();
  
  if (!isAuthenticated) {
    return <Navigate to="/customer/login" replace />;
  }
  
  return <>{children}</>;
};

export const CustomerRoutes: RouteObject[] = [
  {
    path: '/customer/tickets',
    element: (
      <CustomerAuthProvider>
        <CustomerProtectedRoute>
          <CustomerTickets />
        </CustomerProtectedRoute>
      </CustomerAuthProvider>
    ),
  },
]; 